module.exports = "<p>\n  system-activity works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/Dashboard/AdminDashboardPages/system-activity/system-activity.component.html
// module id = ./src/app/home/pages/Dashboard/AdminDashboardPages/system-activity/system-activity.component.html
// module chunks = main